import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors, foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  sidebar: {
    display: "flex",
    flexDirection: "column",
    paddingRight: "24px",
    width: "280px",
    minWidth: "280px",
    gap: "16px",
    overflowY: "auto",
  },
  filterWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  filterHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: "8px",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  titlePadding: {
    paddingTop: "24px",
  },
  foldersHeader: {
    paddingLeft: "8px",
    fontWeight: foundations.typography.fontWeight.medium,
    fontSize: foundations.typography.fontSize.bodyDefault,
  },
  folderIcon: {
    fill: semanticColors.foreground.secondary,
    color: semanticColors.foreground.secondary,
    fontSize: "20px",
  },
  addFolderButton: {
    fontSize: foundations.typography.fontSize.bodySmall,
    color: semanticColors.foreground.action,
    padding: 0,
    minWidth: "unset",
    textTransform: "none",
    fontWeight: foundations.typography.fontWeight.normal,
    "&:hover": {
      backgroundColor: "transparent",
      textDecoration: "underline",
    },
  },
  searchResults: {
    padding: "8px 0",
    fontSize: "10px",
    color: semanticColors.foreground.primary,
    display: "flex",
    flexDirection: "row",
  },
  clearFilter: {
    fontSize: "10px",
    color: semanticColors.foreground.action,
    marginLeft: "4px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  noSectionsView: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "56px",
    gap: "8px",
  },
  scrollContainer: {
    flex: 1,
    minHeight: "0px",
  },
  scrollInner: {},
  navItemButton: {
    borderRadius: "6px",
    marginBottom: "2px",
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: `${semanticColors.background.actionMedium} !important`,
      color: "#FFFFFF",
      "& .MuiListItemIcon-root": {
        color: "#FFFFFF",
      },
      "& .MuiTypography-root": {
        color: "#FFFFFF",
      },
    },
  },
  navItemIcon: {
    minWidth: "unset",
    marginRight: "8px",
    color: semanticColors.foreground.secondary,
  },
  treeNodeButton: {
    padding: "4px 8px",
    borderRadius: "6px",
    marginBottom: "2px",
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: `${semanticColors.background.actionMedium} !important`,
      color: "#FFFFFF",
      "& .MuiListItemIcon-root": {
        color: "#FFFFFF",
      },
      "& .MuiTypography-root": {
        color: "#FFFFFF",
      },
    },
  },
  treeToggleIcon: {
    minWidth: "unset",
    width: "22px",
    marginRight: "4px",
    color: semanticColors.foreground.secondary,
    "& svg": {
      fontSize: "18px",
    },
  },
  treeToggleIconButton: {
    padding: "0px",
    color: "inherit",
    borderRadius: "4px",
  },
  treeToggleIconSpacer: {
    minWidth: "unset",
    width: "22px",
    marginRight: "4px",
  },
  treeNodeText: {
    "& .MuiListItemText-primary": {
      fontSize: foundations.typography.fontSize.bodySmall,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  hideControls: {
    display: "none",
  },
});
